import { UnstyledButton, Flex, Text } from '@mantine/core';
import { ComponentPropsWithoutRef, FC } from 'react';
import { useCheckoutButtonStyles } from './style';

type Props = {
  amount: string;
  onClick: ComponentPropsWithoutRef<'button'>['onClick'];
};

const CheckoutButton: FC<Props> = ({ amount, onClick }) => {
  const { classes } = useCheckoutButtonStyles();
  return (
    <UnstyledButton className={classes.button} type='submit' onClick={onClick}>
      <Flex w='100%' justify='space-between'>
        <Text lh={1}>Checkout</Text>
        <Text lh={1}>|</Text>
        <Text lh={1}>${amount}</Text>
      </Flex>
    </UnstyledButton>
  );
};

export default CheckoutButton;
